import { useContext } from "react";
import { OrbitControls } from "@react-three/drei";

import stateContext from "../Context/StateContext";
import goldPrizeCalculator from "../utils/goldPlateUtils";

export const Camera = () => {
    const globalState = useContext(stateContext);
    const cameraPosY = -goldPrizeCalculator.getPHeight() / 2;
    return (
        <OrbitControls
            enabled
            smoothTime={0.15}
            draggingSmoothTime={0.08}
            truckSpeed={0.00001}
            enablePan={true}
            orbitPoint={[0, cameraPosY, 0]}
            maxDistance={115}
            minDistance={70}
            // minPolarAngle={0}
            // maxPolarAngle={Math.PI * 0.6}
            maxAzimuthAngle={Infinity}
            minAzimuthAngle={-Infinity}
            rotateSpeed={0.5}
            ref={globalState.controlsRef}
        />
    );
};
